import { NextPage } from "next";
import Login from "../../../modules/Authorization/Login/Login";
import AuthPage from "../../../common/components/PageWrappers/AuthPage";

const LoginPage: NextPage = () => (
  <AuthPage>
    <Login />
  </AuthPage>
);

export default LoginPage;
